/*  MUI  */
import { Box, Typography } from '@mui/material';

/* Shared */
import { FontSizes } from 'application/Shared/Constants';
import i18n from 'i18n';

/*  React  */
import React from 'react';

const { t } = i18n;

const StyleText = ({ style, text }) => (
    <Typography variant="p" style={{ ...style }}>
        {text}
    </Typography>
);

export const DateCreated = () => {
    const filters = [
        {
            default: false,
            key: 7,
            name: t('Datecreated.filter.last7day')
        },
        {
            default: false,
            key: 30,
            name: t('Datecreated.filter.last30day')
        },
        {
            default: false,
            key: 90,
            name: t('Datecreated.filter.last90day')
        }
    ];

    const parameter = 'dateAdded';
    const filterableOptions = [];

    filters.forEach((f) => {
        const date = new Date();
        date.setDate(date.getDate() - f.key);
        const value = date.toISOString();

        filterableOptions.push({
            ...f,
            child: true,
            parameter,
            render: (
                <Box display="flex" alignItems="center">
                    <StyleText
                        style={{ fontSize: FontSizes[1] }}
                        text={f.name}
                    />
                </Box>
            ),
            value
        });
    });

    const headers = {
        filterable: true,
        filterableOneOption: true,
        filterableOptions,
        key: parameter,
        name: 'Common.dateDiscovered',
        sortable: true,
        sortableFieldType: 'date',
        sortableKey: parameter,
        width: '10%'
    };

    return headers;
};
